import { IFilterList } from "../../utils/interfaces/FilterListInterface";
import { toPartialQueryString } from "../../utils/parsers/QueryString";

interface IsCustomerWrapped {
    bool: boolean|undefined;
    description: string;
}

export class SubscriberListFilterFormModel implements IFilterList {
    static getIsCustomerList():IsCustomerWrapped[] {
        return [
            {bool: undefined, description: 'Todos'},
            {bool: true, description: 'Clientes reais'},
            {bool: false, description: 'Bases de teste e homologação'},
        ]
    }

    name: string = ""
    document: string = ""
    publicKey: string = ""
    idExternal: string = ""
    alias: string = ""
    isCustomer: IsCustomerWrapped = {
        bool: true,
        description: 'Clientes reais'
    }

    constructor(s?:Partial<SubscriberListFilterFormModel>) {
        Object.assign(this, s)
    }

    isFilterFilled():boolean {
        return !!this.name ||
            !!this.document ||
            !!this.publicKey ||
            !!this.idExternal ||
            !!this.alias ||
            !!this.isCustomer
    }

    toPartialQueryString():string {
        const tmp = {
            ...this,
            isCustomer: this.isCustomer.bool,
        }

        return toPartialQueryString(tmp)
    }
}
